// @ts-nocheck
import { useEffect, useRef, useState, createContext, useContext } from "react";
import axios from "axios";
import storage from "./storage";
import React from "react";
import { useOverlayDisclosure } from "../components/OverlayRouter";

/* 
    exhangeRates - to be updated from backend.
    Object.keys = represent currencies of countries we currently operate in
    aka currency of the tutors
    Object.values = represent currencies we can charge customers in, whether
    we're operating in their countries or not aka currency of clients
  */

//TODO: Users local currency symbol should be saved in their accounts, same
//TODO: as their local time zone for everywhere they enter amounts or time.

//TODO: I made the exchange rate depend on the "symbol" of the currency
//which is wrong because Canada and USA use $ for instance, but the conversion
//is not the same. I have to use a different comparison.

// import ALL_COUNTRIES from "../countries.json";

let supportedCountries = [
  // { name: "United Kingdom", currency: "£" },
  { name: "United States", currency: "$" },
  { name: "Nigeria", currency: "₦" },
  { name: "United States of America", currency: "$" },
];

export const getCountryData = (_country) => {
  let country = _country;
  if (country.toLowerCase() === "united states of america") {
    country = "United States";
  }
  return new Promise((resolve, reject) => {
    const ALL_COUNTRIES: any[] = [];
    let foundCountry = ALL_COUNTRIES.find(
      (x) => x.name.toLowerCase() === country.toLowerCase()
    );
    if (foundCountry) {
      let foundCurrency = supportedCountries.find(
        (x) => x.name.toLowerCase() === foundCountry.name.toLowerCase()
      );
      if (foundCurrency) {
        resolve({ currencySymbol: foundCurrency.currency, dialCode: "" });
      } else {
        resolve({ currencySymbol: "$", dialCode: "" });
      }
    } else {
      reject();
    }
  });
  // return axios
  //   .get(
  //     `https://restcountries.eu/rest/v2/name/${country.toLowerCase()}?fullText=true`
  //   )
  //   .then(response => {
  //     const countryInfo = {
  //       currencySymbol: response.data[0].currencies[0].symbol[0],
  //       dialCode: response.data[0].callingCodes[0]
  //     };
  //     return countryInfo;
  //   });
};

export const useCountryData = (country) => {
  const [countryData, setCountryData] = useState({});

  useEffect(() => {
    getCountryData(country).then((countryInfo) => setCountryData(countryInfo));
  }, [countryData]);

  return countryData;
};

export const fetchCountries = () => {
  return axios
    .get(`https://restcountries.eu/rest/v2/all`)
    .then(({ data }) => data.map((item) => item.name));
};

let IPDATA_API_KEY = "b66ad5c2529766c339602156c1d200369fd5d8256c406d7ed4d3697d";

export const getIPData = () => {
  return axios.get(`https://api.ipdata.co/?api-key=${IPDATA_API_KEY}`);
};

export const useIPData = (defaultIp = {}) => {
  const [data, setData] = useState(defaultIp);

  useEffect(() => {
    if (Object.keys(data).length === 0) {
      getIPData().then((response) => {
        setData(response.data);
      });
    }
  }, []);

  return data;
};

export const useToggle = (initialState = false) => {
  const [isOpen, setIsOpen] = useState(initialState);

  const onClose = () => setIsOpen(false);
  const onToggle = () => setIsOpen(!isOpen);
  const onOpen = () => setIsOpen(true);

  return { isOpen, onOpen, onClose, onToggle };
};

export const useUpdateEffect = (effect, deps) => {
  const mounted = useRef(false);
  useEffect(() => {
    if (mounted.current) {
      effect();
    } else {
      mounted.current = true;
    }
  }, deps);
};

export const validatePhone = (value, country_code = "NG") => {
  const APILAYER_API_KEY = process.env.REACT_APILAYER_API_KEY;
  return axios.get().then(({ data }) => {
    `http://apilayer.net/api/validate?access_key=${APILAYER_API_KEY}&number=${value}&country_code=${country_code}&format=1`;
    return data.valid;
  });
};

// This hook gets the Scroll Position

const isBrowser = typeof window !== `undefined`;

function getScrollPosition() {
  return isBrowser
    ? { x: window.pageXOffset, y: window.pageYOffset }
    : { x: 0, y: 0 };
}

export function useScrollPosition() {
  const [position, setScrollPosition] = useState(getScrollPosition());

  useEffect(() => {
    let requestRunning = null;
    function handleScroll() {
      if (isBrowser && requestRunning === null) {
        requestRunning = window.requestAnimationFrame(() => {
          setScrollPosition(getScrollPosition());
          requestRunning = null;
        });
      }
    }

    if (isBrowser) {
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, []);

  return position;
}

export function useScrollXPosition() {
  const { x } = useScrollPosition();
  return x;
}

export function useScrollYPosition() {
  const { y } = useScrollPosition();
  return y;
}

// Scroll Position Hook stops here.

// form submission loading hook
export const useFormSubmission = (
  onSubmit,
  toNextPage,
  providerAction,
  _session_id,
  nextProps = []
) => {
  let [loading, setLoading] = useState<boolean>(false);
  function submitAction(data) {
    let result = providerAction(data);
    if (_session_id) {
      storage.set(_session_id, result); //to localstorage
    }
    return onSubmit(result);
  }
  function onSubmitForm(data) {
    setLoading(true);
    return submitAction(data)
      .then((params) => {
        toNextPage(params, ...nextProps);
        // setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  }
  return [loading, onSubmitForm];
};

function getValueFromSession(sessionID, key) {
  let data = storage.get(sessionID, undefined);
  if (data) {
    if (key === "all") {
      return data;
    }
    let value = data[key];
    return value;
  }
  return undefined;
}
export function loadDataFromSessionStorage(sessionID, key) {
  let _session_id = sessionID;
  if (!_session_id) {
    _session_id = storage.get("session-id", undefined);
  }
  let value = undefined;
  if (_session_id) {
    value = getValueFromSession(_session_id, key);
  }
  return [_session_id, value];
}

export function saveToStorage(sessionID, value) {
  if (sessionID) {
    storage.set(sessionID, value);
  }
}

const exchangeRates = {
  // "₦": { "₵": 50, S: 2, $: 200, "£": 250, "€": 250 },
  // "₵": { "₦": 0.01, S: 45, $: 100, "£": 150, "€": 150 },
  // S: { "₦": 30, "₵": 15, $: 100, "£": 150, "€": 150 },

  "₦": { $: 200, "£": 250, "€": 250 },
  "₵": { "₦": 0.01, $: 100, "£": 150, "€": 150 },
  S: { "₦": 30, $: 100, "£": 150, "€": 150 },
};

function getResult(toCountry, fromCountry) {
  return Promise.all([getCountryData(toCountry), getCountryData(fromCountry)]);
}
export const getCurrency = (fromCurrency = "₦", toCurrency = "$") => {
  let currencies = Object.values(exchangeRates).map((obj) => Object.keys(obj));
  let supportedCurrencies = [].concat.apply([], currencies);
  supportedCurrencies = Array.from(new Set(supportedCurrencies));

  let fromCurrencies = Object.keys(exchangeRates);
  let isSameCountry = toCurrency === fromCurrency;

  let exchangeFactor =
    fromCurrency && toCurrency
      ? isSameCountry
        ? 1
        : exchangeRates[fromCurrency][toCurrency]
      : 1;

  /*
      This helps calculate the conversion of the amount to the
      new currency. It is a function because it will act as a
      callback to send the amount from each child tutor card to
      the parent component  
     */

  const generateAmount = (initialAmount) => {
    let newAmount = Math.round(initialAmount / exchangeFactor);
    return newAmount;
  };
  return { generateAmount };
};
export function getCurrencyForCountry(country, kind = "from") {
  let defaultCurrency = kind === "to" ? "$" : "₦";
  let currencies = Object.values(exchangeRates).map((obj) => Object.keys(obj));
  let supportedCurrencies = [].concat.apply([], currencies);
  supportedCurrencies = [...new Set(supportedCurrencies)];
  let fromCurrencies = Object.keys(exchangeRates);
  let result = defaultCurrency;
  return getCountryData(country)
    .then((destinationData: any) => {
      if (kind == "to") {
        if (supportedCurrencies.includes(destinationData.currencySymbol)) {
          result = destinationData.currencySymbol;
        }
      } else {
        let v = destinationData;
        if (fromCurrencies.includes(destinationData.currencySymbol)) {
          result = destinationData.currencySymbol;
        }
      }
      return result;
    })
    .catch((e) => {
      return defaultCurrency;
    });
}
export function resolveCurrencyFromCountry(toCountry, fromCountry) {
  return Promise.all([
    getCurrencyForCountry(toCountry),
    getCurrencyForCountry(fromCountry, "from"),
  ]).then((data) => {
    let currency = { to: data[0], from: data[1] };
    return currency;
  });
}
export const useCurrency2 = (defaultToCurrency = "", fromCountry) => {
  const [toCurrency, setToCurrency] = useState(defaultToCurrency);
  const [fromCurrency, setFromCurrency] = useState<string>("");
  const [countryFromIP, setCountryFromIP] = useState(fromCountry);
  const [priceIsFetched, setHasFetchedPrice] = useState(false);
  useEffect(() => {
    if (countryFromIP) {
      setHasFetchedPrice(false);
      resolveCurrencyFromCountry(countryFromIP, countryFromIP).then(
        ({ from, to }: { from: any; to: any }) => {
          if (!defaultToCurrency) {
            setToCurrency(to);
          }
          setFromCurrency(from);
          setHasFetchedPrice(true);
        }
      );
    }
  }, [defaultToCurrency, countryFromIP]);

  const generateAmount = (initialAmount) => {
    let isSameCountry = toCurrency === fromCurrency;

    let exchangeFactor =
      fromCurrency && toCurrency
        ? isSameCountry
          ? 1
          : exchangeRates[fromCurrency][toCurrency]
        : 1;

    let newAmount = Math.round(initialAmount / exchangeFactor);
    return newAmount;
  };
  function setSourceCountry(_fromCountry) {
    setCountryFromIP(_fromCountry);
  }
  return [toCurrency, priceIsFetched, generateAmount, setSourceCountry];
};
export const useCurrency = (toCountry, fromCountry) => {
  let currencies = Object.values(exchangeRates).map((obj) => Object.keys(obj));
  let supportedCurrencies = [].concat.apply([], currencies);
  supportedCurrencies = Array.from(new Set(supportedCurrencies));

  let fromCurrencies = Object.keys(exchangeRates);

  const [countryFromIP, setCountryFromIP] = useState(fromCountry);
  const [toCurrency, setToCurrency] = useState<string>("");
  const [fromCurrency, setFromCurrency] = useState<string>("");
  const [priceIsFetched, setHasFetchedPrice] = useState(false);

  useEffect(() => {
    if (!fromCountry) {
      getIPData()
        .then((res) => {
          let { country_name: country } = res.data;
          setCountryFromIP(country);
        })
        .catch((e) => {
          // console.log(e);
          setCountryFromIP("Nigeria");
        });
    }
  }, []);

  useEffect(() => {
    if (fromCountry || countryFromIP) {
      resolveCurrencyFromCountry(
        toCountry || countryFromIP,
        fromCountry || countryFromIP
      ).then(({ from, to }: { from: any; to: any }) => {
        setToCurrency(to);
        setFromCurrency(from);
        setHasFetchedPrice(true);
      });
      // getResult(toCountry || countryFromIP, fromCountry || countryFromIP)
      //   .then(data => {
      //     let [destinationData, sourceData] = data;
      //     if (supportedCurrencies.includes(destinationData.currencySymbol)) {
      //       setToCurrency(destinationData.currencySymbol);
      //     } else {
      //       setToCurrency("$");
      //     }
      //     if (fromCurrencies.includes(sourceData.currencySymbol)) {
      //       setFromCurrency(sourceData.currencySymbol);
      //     } else {
      //       setFromCurrency("₦");
      //     }
      //     setHasFetchedPrice(true);
      //   })
      //   .catch(e => {
      //     setToCurrency("$");
      //     setFromCurrency("₦");
      //     setHasFetchedPrice(true);
      //   });
    }
  }, [toCountry, countryFromIP, fromCountry]);

  let isSameCountry = toCurrency === fromCurrency;

  let exchangeFactor =
    fromCurrency && toCurrency
      ? isSameCountry
        ? 1
        : exchangeRates[fromCurrency][toCurrency]
      : 1;

  /*
    This helps calculate the conversion of the amount to the
    new currency. It is a function because it will act as a
    callback to send the amount from each child tutor card to
    the parent component  
   */

  const generateAmount = (initialAmount) => {
    let newAmount = Math.round(initialAmount / exchangeFactor);
    return newAmount;
  };
  function setSourceCountry(_fromCountry) {
    setCountryFromIP(_fromCountry);
    // {
    //   fromCountry: currentSearchResult[0].country,
    //   toCountry: contactDetails.country
    // }
  }
  return [toCurrency, priceIsFetched, generateAmount, setSourceCountry];
};

useCurrency.DefaultProps = {
  fromCountry: "Nigeria",
  toCountry: "United States of America",
};

export function useInterval(callback, delay) {
  const savedCallback = React.useRef<any>();

  // Remember the latest callback.
  React.useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  React.useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

export const useOverlayDisclosureWithCrisp = (path) => {
  const {
    isOpen,
    rawClose: modalOnClose,
    rawOpen: modalOnOpen,
  } = useOverlayDisclosure(path);

  const onOpen = () => {
    const crispClient: any = document.querySelector(".crisp-client");
    if (crispClient) {
      crispClient.style.display = "none";
    }
    modalOnOpen(path);
  };

  const onClose = () => {
    const crispClient: any = document.querySelector(".crisp-client");
    if (crispClient) {
      crispClient.style.display = "";
    }
    modalOnClose(path);
  };

  return { isOpen, onClose, onOpen };
};

const VideoValidContext = createContext();
export const useVideoValidContext = () => useContext(VideoValidContext);
export const VideoValidProvider = ({ children }) => {
  const [videoValid, setVideoValid] = useState<string | null>(null);
  const updateVideoValid = (data: any) => {
    setVideoValid(data);
  };
  return (
    <VideoValidContext.Provider value={{ videoValid, updateVideoValid }}>
      {children}
    </VideoValidContext.Provider>
  );
};
